import { createAction, props } from '@ngrx/store';

export const patchViewState = createAction(
   '[VIEW STATE] Patch View State',
   props<{ key: string; value: any }>()
);
